var _path, _rect, _circle, _circle2, _circle3, _circle4, _path2, _rect2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgApiCenter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4456 2C10.832 2 10.3345 2.49746 10.3345 3.11111C10.3345 3.72488 9.83697 4.22244 9.2232 4.22244H5.66753C4.56297 4.22244 3.66753 5.11787 3.66753 6.22244V9.77799C3.66753 10.3916 3.17007 10.8891 2.55642 10.8891C1.94277 10.8891 1.44531 11.3866 1.44531 12.0002C1.44531 12.6139 1.94277 13.1113 2.55642 13.1113C3.17007 13.1113 3.66753 13.6088 3.66753 14.2224V15.3335C3.66753 15.9472 3.17007 16.4447 2.55642 16.4447C1.94277 16.4447 1.44531 16.9421 1.44531 17.5558C1.44531 18.1694 1.94277 18.6669 2.55642 18.6669C3.17007 18.6669 3.66753 19.1643 3.66753 19.778V20.8891C3.66753 21.5028 3.17007 22.0002 2.55642 22.0002C1.94277 22.0002 1.44531 22.4977 1.44531 23.1113C1.44531 23.725 1.94277 24.2224 2.55642 24.2224C3.17007 24.2224 3.66753 24.7199 3.66753 25.3335V28.8891C3.66753 29.9937 4.56296 30.8891 5.66753 30.8891H28.3342C29.4388 30.8891 30.3342 29.9937 30.3342 28.8891V25.3335C30.3342 24.7199 30.8317 24.2224 31.4453 24.2224C32.059 24.2224 32.5564 23.725 32.5564 23.1113C32.5564 22.4977 32.059 22.0002 31.4453 22.0002C30.8317 22.0002 30.3342 21.5028 30.3342 20.8891V19.778C30.3342 19.1643 30.8317 18.6669 31.4453 18.6669C32.059 18.6669 32.5564 18.1694 32.5564 17.5558C32.5564 16.9421 32.059 16.4447 31.4453 16.4447C30.8317 16.4447 30.3342 15.9472 30.3342 15.3336V14.2224C30.3342 13.6088 30.8317 13.1113 31.4453 13.1113C32.059 13.1113 32.5564 12.6139 32.5564 12.0002C32.5564 11.3866 32.059 10.8891 31.4453 10.8891C30.8317 10.8891 30.3342 10.3916 30.3342 9.778V6.22244C30.3342 5.11787 29.4388 4.22244 28.3342 4.22244H24.7792C24.1654 4.22244 23.6679 3.72488 23.6679 3.11111C23.6679 2.49746 23.1704 2 22.5567 2C21.9431 2 21.4456 2.49746 21.4456 3.11111C21.4456 3.72488 20.9481 4.22244 20.3343 4.22244H19.2236C18.6099 4.22244 18.1123 3.72488 18.1123 3.11111C18.1123 2.49746 17.6148 2 17.0012 2C16.3875 2 15.8901 2.49746 15.8901 3.11111C15.8901 3.72488 15.3925 4.22244 14.7788 4.22244H13.6681C13.0543 4.22244 12.5567 3.72488 12.5567 3.11111C12.5567 2.49746 12.0593 2 11.4456 2Z",
    fill: "url(#paint0_linear_646_10940)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.89062,
    y: 6.44482,
    width: 22.2222,
    height: 22.2222,
    fill: "url(#paint1_linear_646_10940)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.11111,
    cy: 8.66726,
    r: 1.11111,
    fill: "#78CFB5"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 25.8904,
    cy: 8.66726,
    r: 1.11111,
    fill: "#78CFB5"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.11111,
    cy: 26.4451,
    r: 1.11111,
    fill: "#78CFB5"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 25.8904,
    cy: 26.4451,
    r: 1.11111,
    fill: "#78CFB5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.998 18.4812L12.238 17.6892C12.43 17.0492 12.614 16.4012 12.782 15.7292H12.814C12.998 16.3932 13.174 17.0492 13.374 17.6892L13.606 18.4812H11.998ZM14.326 20.8892H15.31L13.358 15.0012H12.286L10.334 20.8892H11.278L11.782 19.2092H13.83L14.326 20.8892ZM16.0865 20.8892H17.0145V18.6572H17.9025C19.1825 18.6572 20.1185 18.0652 20.1185 16.7772C20.1185 15.4492 19.1825 15.0012 17.8705 15.0012H16.0865V20.8892ZM17.0145 17.9132V15.7452H17.7825C18.7185 15.7452 19.2065 16.0012 19.2065 16.7772C19.2065 17.5532 18.7585 17.9132 17.8145 17.9132H17.0145ZM21.2662 20.8892H22.1942V15.0012H21.2662V20.8892Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color"
    }
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_646_10940",
    x1: 17.0009,
    y1: 2,
    x2: 17.0009,
    y2: 30.8889,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74CDB2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9AE4D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_646_10940",
    x1: 8.11285,
    y1: 12.2419,
    x2: 24.1872,
    y2: 28.4868,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1F8EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3EEDB"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApiCenter);
export default "https://cdn.d2cgo.com/dtc_center/v19/content_assets/static/media/apiCenter.fc7c11a9c8ea9d0c6b5d7c2539137f5e.svg";
export { ForwardRef as ReactComponent };